import type { ReactNode } from 'react';

type SurfaceProps = {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  /** Убирает внутренние отступы — для таблиц и табов. */
  flush?: boolean;
  className?: string;
};

export function Surface({ title, actions, children, flush = false, className }: SurfaceProps) {
  return (
    <section className={['surface', className].filter(Boolean).join(' ')}>
      {(title !== undefined || actions !== undefined) && (
        <header className="surface__header">
          {title !== undefined ? <h2 className="surface__title">{title}</h2> : <span />}
          {actions !== undefined ? <div className="page-header__actions">{actions}</div> : null}
        </header>
      )}
      <div className={flush ? 'surface__body surface__body--flush' : 'surface__body'}>
        {children}
      </div>
    </section>
  );
}
